import './FileUpload.css';
import React, { useMemo, useRef } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as UploadIcon } from '../../../resources/icons/upload.svg';
export let FileUploadError = /*#__PURE__*/function (FileUploadError) {
  FileUploadError["Oversized"] = "Oversized";
  FileUploadError["IncorectType"] = "IncorectType";
  FileUploadError["IncorectName"] = "fileNameError";
  return FileUploadError;
}({});
const FileUpload = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const inputRef = useRef(null);
  const extensions = useMemo(() => props.supportedFormats && props.supportedFormats.map(e => `.${e.toLowerCase()}`), [props.supportedFormats]);
  const verifyFile = file => {
    var regexName = /^[a-zA-Z0-9 ._-]+$/;
    if (file.name && !regexName.test(file.name)) {
      return FileUploadError.IncorectName;
    }
    if (extensions && !extensions.some(extension => file.name.endsWith(extension))) {
      return FileUploadError.IncorectType;
    }
    if (props.maxSizeKb && props.maxSizeKb * 1024 < file.size) {
      return FileUploadError.Oversized;
    }
    return null;
  };
  const onChangeEvent = fileList => {
    if (fileList && fileList.length) {
      const error = verifyFile(fileList[0]);
      if (error) {
        props.onError && props.onError(error, fileList[0]);
      } else {
        props.onChange(fileList[0]);
      }
    }
  };
  const onUploadButtonClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.click();
    }
  };
  const dropHandler = e => {
    e.preventDefault();
    onChangeEvent(e.dataTransfer.files);
  };
  const onUploadInputHandler = e => {
    onChangeEvent(e.target.files);
    e.target.value = '';
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-upload"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, props.title && /*#__PURE__*/React.createElement("h3", {
    className: "file-upload__title"
  }, props.title), props.description && /*#__PURE__*/React.createElement("p", {
    className: "file-upload__description"
  }, props.description), /*#__PURE__*/React.createElement("div", {
    className: "file-upload__drag-and-drop",
    onDrop: dropHandler,
    onDragOver: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("input", {
    className: "file-upload__input",
    ref: inputRef,
    type: "file",
    onChange: onUploadInputHandler,
    accept: extensions && extensions.join(', ')
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-upload__text-with-icon"
  }, /*#__PURE__*/React.createElement(UploadIcon, {
    className: "file-upload__upload-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-upload__drag-n-drop-text"
  }, props.dragNdropText)), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary file-upload__btn",
    onClick: onUploadButtonClick
  }, props.uploadButtonLabel)), /*#__PURE__*/React.createElement("div", {
    className: "file-upload__limits"
  }, props.supportedFormatsLabel && props.supportedFormats && props.supportedFormats.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "file-upload__formats"
  }, props.supportedFormatsLabel.replace('$value$', props.supportedFormats.map(el => el.toUpperCase()).join('/'))), props.maxSizeLabel && props.maxSizeKb && /*#__PURE__*/React.createElement("div", {
    className: "file-upload__max-size"
  }, props.maxSizeLabel.replace('$value$', `${props.maxSizeKb}`))))));
};
export default FileUpload;
const StyledWrapper = _ref => {
  let {
    children,
    rtl
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1w5doeg";
const ltrStyles = "lnt6uo9";
const rtlStyles = "r98yxi";